import { BIOMETRICS_BUTTON_DATA_TYPE } from 'pages/PageEditor/constants';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorBiometricsButton = customizeCraftJsComponent(EditorButton, {
	name: 'Biometrics Button',
	props: {
		children: '',
		startIcon: 'fingerprint',
		shape: 'square',
		variant: 'outline',
		startIconColorText: true,
		'data-type': BIOMETRICS_BUTTON_DATA_TYPE
	}
});
